<script setup lang="ts">
    import { LivestreamRouteName } from '@/types/router/name/livestreams';
    import { PhArrowLeft } from '@phosphor-icons/vue';

    defineOptions({
        name: 'LivestreamForm'
    });
</script>
<template>
    <div class="w-full h-screen relative">
        <div class="fixed z-10 w-full p-6 bg-white shadow-form-live">
            <div
                @click="$router.push({ name: LivestreamRouteName.Livestreams })"
                class="cursor-pointer flex flex-row gap-4 items-center text-default"
            >
                <PhArrowLeft size="24" weight="regular" />
                <h3>Buat Siaran Pengajian</h3>
            </div>
        </div>
        <div class="h-full w-full overflow-auto justify-items-center bg-form-live px-6">
            <div class="mt-[76px] mb-[100px] w-full max-w-[1050px]">
                <RouterView />
            </div>
        </div>
        <div class="fixed bottom-0 z-10 p-6 w-full bg-white shadow-form-live justify-items-center">
            <div class="w-full max-w-[1050px] flex flex-row gap-4 items-center justify-end">
                <ButtonGhost
                    @click="$router.push({ name: LivestreamRouteName.Livestreams })"
                    class="max-w-fit"
                    size="large"
                    type="primary"
                    >Batal</ButtonGhost
                >
                <ButtonPrimary @click.prevent="" class="max-w-fit" size="large" type="primary"
                    >Simpan</ButtonPrimary
                >
            </div>
        </div>
    </div>
</template>
